var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SystemCard',{staticClass:"mb-4",attrs:{"title":_vm.data.title ? _vm.data.title : 'response'}},[_c('VueJsonPretty',{attrs:{"slot":"cardData","path":'res',"data":_vm.data.json ? _vm.data.json : ''},slot:"cardData"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }